<template>
  <div class="js">
    <div class="container">
      <!-- 右侧 -->
      <div class="js-r">
        <h2>北京猫闪科技有限公司</h2>
        <p> 北京猫闪科技有限公司成立于2012年07月10日，注册地位于北京市海淀区中关村大街18号科贸电子城5C51-2，经营范围包括计算机软硬件的技术开发、技术咨询、技术转让、技术培训、技术服务；销售计算机、软硬件及外围设备、五金交电、电子元器件、机械、电器设备、通讯设备；维修计算机、手机。（企业依法自主选择经营项目，开展经营活动；依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。）</p>
        
     
      </div>
      <!-- 左侧 -->
      <div class="js-l">
        <img src="/imgs/js1.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.js {
  width: 100%;
  height: 360px;
  margin: 50px auto;

  // background: pink;
  .container {
    @include flex();

    height: 100%;
    .js-l {
      width: 50%;
      height: 100%;
      background: #c59012;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .js-r {
      width: 50%;
      height: 100%;
      background-color: #fff;
      margin-left: 30px;
      padding: 20px;
      box-sizing: border-box;
      h2 {
        font-size: 21px;
        font-weight: 400;
        color: #333;
      }
      p {
        font-size: 14px;
        color: #888;
        line-height: 30px;
        margin: 35px 0;
        text-indent: 20px;
      }
    }
  }
}
</style>